module.exports = __webpack_public_path__ + "img/矢量智能对象.cba2d332.png";